import { CommunityFocus } from 'src/app/swagger-api';
import ProjectLinks from '../../common/project.links';
import {
  NotificationMessagePayload,
  ProjectInvitationNotification,
  ProjectMemberExcludedNotification,
} from './interfaces';
import { BaseCommunityInterface } from './interfaces/base-community.interface';

export function doctorPatientLinkInitiatorError(initiator: string): never {
  throw new Error(`Unexpected doctor-patient link initiator: ${initiator}`);
}

export const eventBasedCommunityLink = (data: BaseCommunityInterface) => {
  const focus: CommunityFocus = (data.community_focus ?? 'HEALTH') as CommunityFocus;
  const route = focus === 'CHARITY' ? ProjectLinks.LINK_CHARITY_VIEW : ProjectLinks.LINK_COMMUNITY_VIEW;

  return `${route}/${data.community_id}`;
};

export function createInviteToProjectMessage(
  data: ProjectInvitationNotification,
  text: string | string[],
): NotificationMessagePayload[] {
  const response: NotificationMessagePayload[] = [];
  const projectInfo: NotificationMessagePayload = {
    text: data.project_title,
  };
  if (!data.is_private) {
    projectInfo.href = `${ProjectLinks.LINK_PROJECTS_VIEW}/${data.project_id}`;
  }
  response.push(
    {
      text: data.initiator_name,
      href: `${ProjectLinks.LINK_PROFILE_VIEW}/${data.initiator_account_id}`,
    },
    { text: text[0] },
    projectInfo,
    { text: text[1] },
  );
  return response;
}

export const getPropertyGuarded: (data: object, property: PropertyKey) => string | undefined = (
  data: object,
  property: PropertyKey,
) => {
  function hasProperty(data: object, property: PropertyKey): property is keyof object {
    return property in data;
  }
  return hasProperty(data, property) ? data[property] : undefined;
};

export function createRemoveFromProjectMessage(
  data: ProjectMemberExcludedNotification,
  text: string | string[],
): NotificationMessagePayload[] {
  const response: NotificationMessagePayload[] = [];
  const projectInfo: NotificationMessagePayload = {
    text: data.project_title,
  };
  if (!data.is_private) {
    projectInfo.href = `${ProjectLinks.LINK_PROJECTS_VIEW}/${data.project_id}`;
  }
  response.push(
    {
      text: data.initiator_name,
      href: `${ProjectLinks.LINK_PROFILE_VIEW}/${data.initiator_account_id}`,
    },
    { text },
    projectInfo,
  );
  return response;
}

export const routeMapper: { [key: string]: string } = {
  Project: ProjectLinks.LINK_PROJECTS_VIEW,
  Post: ProjectLinks.LINK_POSTS_VIEW,
};
